import React, { useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import headerLogo from "../assets/images/mevedir-logo.png";
import himalayaLogo from "../assets/images/himalayblack.png";
import vartohLogo from "../assets/images/vartohlogo.avif";
// import headerBg from "../assets/images/headerbg.jpg";
import "../styles/components/_shop-products.scss";

const Header = () => {
  // eslint-disable-next-line no-unused-vars
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProductsDropdownOpen, setIsProductsDropdownOpen] = useState(false);
  const [isStoresDropdownOpen, setIsStoresDropdownOpen] = useState(false);
  const location = useLocation(); // Get the current route

  // No need for click outside since we're using hover
  const closeTimerRef = useRef(null);

  const cancelCloseTimer = () => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  };

  const scheduleClose = () => {
    cancelCloseTimer();
    closeTimerRef.current = setTimeout(() => {
      setIsProductsDropdownOpen(false);
      setIsStoresDropdownOpen(false);
    }, 180); // small delay to allow moving into panel
  };

  const handleProductsMouseEnter = () => {
    cancelCloseTimer();
    setIsProductsDropdownOpen(true);
    setIsStoresDropdownOpen(false); // Close stores dropdown
  };

  const handleStoresMouseEnter = () => {
    cancelCloseTimer();
    setIsStoresDropdownOpen(true);
    setIsProductsDropdownOpen(false); // Close products dropdown
  };

  const toggleProductsOpen = () => {
    cancelCloseTimer();
    setIsProductsDropdownOpen((prev) => !prev);
    setIsStoresDropdownOpen(false);
  };

  const toggleStoresOpen = () => {
    cancelCloseTimer();
    setIsStoresDropdownOpen((prev) => !prev);
    setIsProductsDropdownOpen(false);
  };

  const handleDropdownMouseLeave = () => {
    scheduleClose();
  };

  const handleLearnMore = (e) => {
    // First, immediately update React state
    setIsProductsDropdownOpen(false);
    setIsStoresDropdownOpen(false);
    
    // Clear any pending timers
    cancelCloseTimer();
    
    // Use a more reliable approach with setTimeout to ensure state is updated
    // before navigation happens
    setTimeout(() => {
      // This will run after the current event loop, ensuring React has updated the DOM
      try {
        // Force hide dropdowns with inline styles (most reliable cross-browser)
        const productsDropdown = document.querySelector('.products-dropdown-content');
        const storesDropdown = document.querySelector('.stores-dropdown-content');
        
        if (productsDropdown) {
          productsDropdown.style.cssText = "display: none !important; opacity: 0 !important; visibility: hidden !important;";
        }
        
        if (storesDropdown) {
          storesDropdown.style.cssText = "display: none !important; opacity: 0 !important; visibility: hidden !important;";
        }
      } catch (error) {
        // Silently handle any errors that might occur
        console.log("Error hiding dropdowns:", error);
      }
    }, 0);
    
    // Return true to allow navigation to proceed
    return true;
  };


  // Check if current path matches the link
  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/" && !location.hash;
    }
    if (path === "/#contact") {
      return location.hash === "#contact";
    }
    return location.pathname === path;
  };

  return (
    <header className={`site-header `}>
      <div className="header-container">
        <div className="logo">
          <Link to="/">
            <img src={headerLogo} alt="Site Logo" width="150" height="50" />
          </Link>
        </div>

        {/* Render the full header only on the home route */}
        {/* {isHomeRoute && ( */}
        <>
          <nav className={`nav-menu ${isMobileMenuOpen ? "active" : ""}`}>
            <div className={`nav-item ${isActive("/") ? "active" : ""}`}>
              <Link to="/">Home</Link>
            </div>
            
            {/* Products Dropdown */}
            <div 
              className={`nav-item products-dropdown ${isProductsDropdownOpen ? "active" : ""}`}
              onMouseEnter={handleProductsMouseEnter}
              onMouseLeave={handleDropdownMouseLeave}
            >
              <Link to="#" onClick={(e) => { e.preventDefault(); toggleProductsOpen(); }}>
                Products We Export
                <span className="dropdown-arrow">▼</span>
              </Link>
              <div 
                className={`products-dropdown-content ${isProductsDropdownOpen ? "active" : ""}`}
                onMouseEnter={handleProductsMouseEnter}
                onMouseLeave={handleDropdownMouseLeave}
              >
                <div className="products-container">
                  <Link 
                    to="/dalle-khursani" 
                    className="product-item-link" 
                    onClick={(e) => {
                      e.preventDefault(); // Prevent default navigation
                      handleLearnMore();  // Close dropdowns
                      // Navigate after a small delay to ensure dropdowns are closed
                      setTimeout(() => {
                        window.location.href = "/dalle-khursani";
                      }, 10);
                    }}
                  >
                    <div className="product-item">
                      <h3 className="product-title">Dalle Khursani</h3>
                      <p className="product-subtitle">Spicy Red Cherry Pepper</p>
                      <p className="product-description">
                        Premium Dalle Khursani from Sikkim with authentic Himalayan flavor and export quality.
                      </p>
                    </div>
                  </Link>
                  <Link 
                    to="/ghost-pepper" 
                    className="product-item-link" 
                    onClick={(e) => {
                      e.preventDefault();
                      handleLearnMore();
                      setTimeout(() => {
                        window.location.href = "/ghost-pepper";
                      }, 10);
                    }}
                  >
                    <div className="product-item">
                      <h3 className="product-title">Bhut Jolokia</h3>
                      <p className="product-subtitle">World's Hottest Ghost Pepper</p>
                      <p className="product-description">
                        Premium Bhut Jolokia with 1M+ Scoville units, perfect for spice enthusiasts.
                      </p>
                    </div>
                  </Link>
                  <Link 
                    to="/hard-cheese" 
                    className="product-item-link" 
                    onClick={(e) => {
                      e.preventDefault();
                      handleLearnMore();
                      setTimeout(() => {
                        window.location.href = "/hard-cheese";
                      }, 10);
                    }}
                  >
                    <div className="product-item">
                      <h3 className="product-title">Hard Cheese</h3>
                      <p className="product-subtitle">Traditional Himalayan Churpi</p>
                      <p className="product-description">
                        Premium Churpi from Sikkim, popular as natural dog treats and export quality.
                      </p>
                    </div>
                  </Link>
                  <Link 
                    to="/large-cardamom" 
                    className="product-item-link" 
                    onClick={(e) => {
                      e.preventDefault();
                      handleLearnMore();
                      setTimeout(() => {
                        window.location.href = "/large-cardamom";
                      }, 10);
                    }}
                  >
                    <div className="product-item">
                      <h3 className="product-title">Large Cardamom</h3>
                      <p className="product-subtitle">Authentic Himalayan Spice</p>
                      <p className="product-description">
                        Premium large cardamom known for its distinct aroma and flavor.
                      </p>
                    </div>
                  </Link>
                  <Link 
                    to="/beetroot-powder" 
                    className="product-item-link" 
                    onClick={(e) => {
                      e.preventDefault();
                      handleLearnMore();
                      setTimeout(() => {
                        window.location.href = "/beetroot-powder";
                      }, 10);
                    }}
                  >
                    <div className="product-item">
                      <h3 className="product-title">Beetroot Powder</h3>
                      <p className="product-subtitle">100% Natural & Nutrient Rich</p>
                      <p className="product-description">
                        Pure beetroot powder rich in nutrients, perfect for smoothies and cooking.
                      </p>
                    </div>
                  </Link>
                  <Link 
                    to="/honey-apis" 
                    className="product-item-link" 
                    onClick={(e) => {
                      e.preventDefault();
                      handleLearnMore();
                      setTimeout(() => {
                        window.location.href = "/honey-apis";
                      }, 10);
                    }}
                  >
                    <div className="product-item">
                      <h3 className="product-title">Honey Apis Cerana</h3>
                      <p className="product-subtitle">Pure Himalayan Honey</p>
                      <p className="product-description">
                        Pure and natural honey from Apis Cerana bees, harvested from the Himalayas.
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            
            {/* Stores Dropdown */}
            <div 
              className={`nav-item stores-dropdown ${isStoresDropdownOpen ? "active" : ""}`}
              onMouseEnter={handleStoresMouseEnter}
              onMouseLeave={handleDropdownMouseLeave}
            >
              <Link to="#" onClick={(e) => { e.preventDefault(); toggleStoresOpen(); }}>
                Our Stores
                <span className="dropdown-arrow">▼</span>
              </Link>
              <div 
                className={`stores-dropdown-content ${isStoresDropdownOpen ? "active" : ""}`}
                onMouseEnter={handleStoresMouseEnter}
                onMouseLeave={handleDropdownMouseLeave}
              >
                <div className="stores-container">
                  <div className="store-item">
                    <img
                      src={himalayaLogo}
                      alt="Himalay Frsh"
                      className="store-logo"
                      width="120"
                      height="60"
                    />
                    <h3 className="store-title">Himalay Frsh</h3>
                    <p className="store-description">
                      Experience the authentic taste of Himalayan organic products. Fresh, natural, and sustainably sourced from the heart of the Himalayas.
                    </p>
                    <a
                      href="https://himalayfrsh.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="visit-btn"
                      onClick={(e) => {
                        // Don't prevent default here since we want to open in new tab
                        handleLearnMore();
                      }}
                    >
                      Visit Store
                    </a>
                  </div>
                  <div className="store-item">
                    <img
                      src={vartohLogo}
                      alt="Vartoh Organic"
                      className="store-logo"
                      width="120"
                      height="60"
                    />
                    <h3 className="store-title">Vartoh Organic</h3>
                    <p className="store-description">
                      Discover Premium Organic products from Vartoh Organic. Carefully selected and certified organic items for your healthy lifestyle.
                    </p>
                    <a
                      href="https://www.vartohorganic.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="visit-btn"
                      onClick={(e) => {
                        // Don't prevent default here since we want to open in new tab
                        handleLearnMore();
                      }}
                    >
                      Visit Store
                    </a>
                  </div>
                </div>
              </div>
            </div>
            
            <div className={`nav-item ${isActive("/blogs") ? "active" : ""}`}>
              <Link to="/blogs">Blog</Link>
            </div>
            <div className={`nav-item ${isActive("/#contact") ? "active" : ""}`}>
              <Link to="/#contact">Contact</Link>
            </div>
          </nav>
          <div className="email">
            <a href="mailto:saileshsherpa@mevedir.com">saileshsherpa@mevedir.com</a>
          </div>
        </>
        {/* )} */}
      </div>
    </header>
  );
};

export default Header;
